import { Component, EventEmitter, Input, Output, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { BookingDto } from '@shared/src/dtos/booking/BookingDto';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { PartnerCategories } from '@shared/src/enums/PartnerCategories';
import { BookingPartnerDto } from '@shared/src/dtos/booking/BookingPartnerDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { SortPartnerCategories } from '@shared/src/filters/SortPartnerCategories';

@Component({
  selector: 'shared-booking-partner-selector',
  templateUrl: './shared.booking.partnerselector.component.html',
  styleUrls: ['./shared.booking.partnerselector.component.scss']
})
export class SharedBookingPartnerSelectorComponent implements OnInit {

  constructor(protected fb: FormBuilder, protected bookingController: BookingController,
    @Inject('SecurityController') protected securityController: SecurityController) {
    this.formGroup = fb.group({
      
    })
  }

  ngOnInit(): void { }

  @Input() readonly: boolean = false;

  private _mode: string = "read"; //"read" | "write"
  @Input() public set mode(v: string) {
    if (v == this.mode)
      return;

    this._mode = v;
  }
  public get mode(): string {
    return this._mode;
  }

  @Input() formGroup: FormGroup;

  public showPartners: boolean;
  public algunAMostrar: boolean;
  public partners: Map<PartnerCategories, Array<BookingPartnerDto>>;
  private _booking: BookingDto;
  @Input() public set booking(v: BookingDto) {
    if (v && this._booking && JSON.stringify(this._booking) == JSON.stringify(v))
      return;

    this._booking = v;

    if(this._booking && this._booking.partners){
      this.partners = new Map(
        Object.entries(this._booking.partners) as [PartnerCategories, Array<BookingPartnerDto>][]
      );
    }else{
      this.partners = new Map<PartnerCategories, Array<BookingPartnerDto>>();
    }
    this.showPartners = this.partners != null && this.partners.size > 0;
    this.loadAlgunAMostrar();
  }
  public get booking(): BookingDto {
    return this._booking;
  }

  /**
   * Ho poso aqui i no amb una pipe adicional perquè sino, fa l'ordre constantment i fa crides constants a back recuperant els partners
   */
  sortCategories = (a: any, b: any): number => {
    return SortPartnerCategories.compareKeys(a.key, b.key);
  };

  public hasPartners(partner: BookingPartnerDto, hasresults: boolean){
    partner.showPartnerOnScreen = hasresults;
    this.loadAlgunAMostrar();
  }

  public loadAlgunAMostrar(){
    if(!this.showPartners)
      return false;

    let _algunAMostrar: boolean = false;
    let partnersArray = Array.from(this.partners.entries());
    for (const [category, partnersList] of partnersArray) {
      for (const partner of partnersList) {
        if(partner.showPartnerOnScreen && partner.partnerIsMine){
          _algunAMostrar = true;
          break;
        }
      }
      if(_algunAMostrar)
        break;
    }
    
    this.algunAMostrar = _algunAMostrar;
  }

  @Output() public onSave: EventEmitter<BookingDto> = new EventEmitter<BookingDto>();
  public setPartner(partnerId: number, oldPartnerId: number, category: PartnerCategories) {
    partnerId = !HLong.isNullOrNullLong(partnerId) ? partnerId : 0;
    oldPartnerId = !HLong.isNullOrNullLong(oldPartnerId) ? oldPartnerId : 0;
    this.bookingController.setPartner(this._booking.bookingId, partnerId, oldPartnerId, category).subscribe(e => {
      if (e && e.bookingId) {
        this.booking = e;
        this.onSave.emit(e);
      }
    })
  }

  pretty(val: any) {
    return JSON.stringify(val);
  }

}
